import { useEffect, useState } from "react";
import { defaultOnboardingFormData } from "../constants/onboarding";

/**
* Custom hook to manage onboarding form data state.
* Persists form data in sessionStorage to maintain state across page reloads.
* 
* @returns {{
*   formData: typeof defaultOnboardingFormData;  // Current onboarding form data state
*   setFormData: React.Dispatch<React.SetStateAction<typeof defaultOnboardingFormData>>; // Setter to update form data
*   clearData: () => void;                        // Function to clear stored onboarding data and reset to default
* }}
*/
export const useOnboardingData = () => {
    // Onboarding form data
    const [formData, setFormData] = useState(() => {
        const saved = sessionStorage.getItem("onboardingData");
        return saved ? JSON.parse(saved) : defaultOnboardingFormData
    });
    // Save to sessionStorage every time formData changes
    useEffect(() => {
        sessionStorage.setItem("onboardingData", JSON.stringify(formData));
    }, [formData]);
    // Clear onboarding data
    const clearData = () => {
        sessionStorage.removeItem("onboardingData");
        setFormData({ ...defaultOnboardingFormData })
    }
    return {formData, setFormData, clearData}
};